module.exports = __webpack_public_path__ + "img/ISBKTRIS.e92ac800.png";